import { AxiosError } from 'axios'

export const isAxios422Error = (
  variableToCheck: unknown
): variableToCheck is AxiosError =>
  (variableToCheck as AxiosError).response?.status === 422
